var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframeTypebot"},[_c('iframe',{ref:"typebotIframe",attrs:{"src":_vm.typebotUrl,"height":"100%","scrolling":"true","width":"100%","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }